/**
 * Why there is nothing to read yet, in one place.
 *
 * The grid said which of four things was true: a run is going, the proposal is
 * closed, nothing in it can move pay, or nobody has run it. The PayPacks lens
 * beside it said "Run the comparison" in all four cases, so a reader watching a
 * run in progress was told to start one, and a reader on a closed proposal was
 * told to do something they cannot do.
 */
export const notReadyNote = (
  state: {
    /** A run is going now. */
    running?: boolean;
    /** The proposal can still be worked on. */
    editable: boolean;
    /** Anything in the proposal could move a number. */
    payMayMove: boolean;
  },
  /** What the reader would get out of running one, in this lens. */
  invitation: string,
) => {
  if (state.running)
    return "Your payroll is being calculated twice: once with today's rules and once with your proposal.";
  if (!state.editable)
    return "This proposal is closed, so there is nothing left to compare. Open the current rules to start a new one.";
  if (!state.payMayMove)
    return "Nothing in this proposal changes how pay is calculated, so there is nothing to compare. Describe a change and this will run on its own.";
  return invitation;
};
